import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'dealerSigned.title',
    defaultMessage: 'Congratulations!',
  },
  detail1: {
    id: 'dealerSigned.detail1',
    defaultMessage: 'Thank you for signing your contract agreement!',
  },
  detail2: {
    id: 'dealerSigned.detail2',
    defaultMessage: 'You can close this page',
  },
});

export default messages;
